import {css, html, LitElement} from 'lit';
import {styleMap} from 'lit/directives/style-map.js';
import {customElement, property} from 'lit/decorators.js';
import global_css from './global-css';
import Decimal from './break_infinity';

@customElement('smooth-progress')
export class SmoothProgress extends LitElement {
  @property({type: Decimal}) value = new Decimal(0);
  @property({type: Decimal}) min = new Decimal(0);
  @property({type: Decimal}) max = new Decimal(1);
  @property() text = '';

  static override styles = [
    global_css,
    css`
      :host {
        padding: 0px;
      }
      .progress-container {
        width: 100%;
        height: 100%;
        background-color: #fff8;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
      }
      .progress-bar {
        /* width: 50%; */
        height: 100%;
        background-color: rgb(var(--value-color, var(--none-color, black)), 1);
        transition: width 0.5s ease-out;
      }

      .progress-bar::before {
        content: attr(data-text);
        white-space: nowrap;
        position: absolute;
        top: calc(50% - 0.6em);
        left: 1ch;
        mix-blend-mode: difference;
        /* color: #888; */
        color: rgb(var(--value-color, var(--none-color, black)), 1);
        /* --hue: 0;
        --saturation: 100%;
        --lightness: 100%;
        color: hsl(var(--hue), var(--saturation), var(--lightness)); */
        font-weight: bolder;
      }
    `,
  ];

  override render() {
    return html`<div class="progress-container">
      <div
        data-text=${this.text}
        class="progress-bar"
        style=${styleMap({
          width: `${this.value.add(this.min).div(this.max).times(100)}%`,
        })}
      >
        <slot></slot>
      </div>
    </div>`;
  }
}
